import React from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Box,
  Link,
} from "@mui/material";

export default function QueryFormTrialVersion() {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ mt: 4, p: 4 }}>
          <Typography variant="h4" gutterBottom align="center" color="primary">
            Betazen Security System
          </Typography>
          <Typography variant="subtitle1" gutterBottom align="center">
            Enterprise-Grade Cybersecurity Trial
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Full Name"
                  variant="outlined"
                  sx={{ mb: 3 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  type="email"
                  label="Work Email"
                  variant="outlined"
                  sx={{ mb: 3 }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Phone Number"
                  variant="outlined"
                  inputMode="tel"
                  sx={{ mb: 3 }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Company Name"
                  variant="outlined"
                  sx={{ mb: 3 }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Security Requirements"
                  variant="outlined"
                  multiline
                  rows={4}
                  sx={{ mb: 3 }}
                  placeholder="Describe your organization's security needs, compliance requirements, and protection goals..."
                />
              </Grid>
            </Grid>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              sx={{ mt: 3, py: 1.5 }}
            >
              Start 30-Day Enterprise Trial
            </Button>
          </form>
        </Paper>

        <Box
          sx={{
            mt: 4,
            p: 3,
            bgcolor: "background.paper",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Protected by Betazen's Zero-Trust Policy • ISO 27001 Certified
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={2}>
            By continuing, you agree to our{" "}
            <Link href="#" color="primary">
              Service Agreement
            </Link>{" "}
            and{" "}
            <Link href="#" color="primary">
              Data Protection Terms
            </Link>
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={2}>
            © 2023 Betazen CyberShield Technologies
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            24/7 Support: +1 (888) 888-8888 • Enterprise Sales:
            enterprise@betazen.com
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
